
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { IDTypesList } from "./IDTypesList";
import { SubmittedDocuments } from "./SubmittedDocuments";
import { useIsMobile } from "@/hooks/use-mobile";
import { VerificationRulesTab } from "./VerificationRulesTab";

export function IdentityDocsManagement() {
  const [activeTab, setActiveTab] = useState("submitted");
  const isMobile = useIsMobile();

  return (
    <div className="w-full max-w-full overflow-hidden">
      <Tabs defaultValue={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className={`grid w-full mb-4 md:mb-6 ${isMobile ? "grid-cols-1 gap-1 h-auto" : "grid-cols-3"}`}>
          <TabsTrigger 
            value="submitted" 
            className={`${isMobile ? "py-3 text-sm justify-start" : ""}`}
          >
            {isMobile ? "📄 Documents" : "Submitted Documents"}
          </TabsTrigger>
          <TabsTrigger 
            value="types" 
            className={`${isMobile ? "py-3 text-sm justify-start" : ""}`}
          >
            {isMobile ? "🆔 Types" : "ID Document Types"}
          </TabsTrigger>
          <TabsTrigger 
            value="rules" 
            className={`${isMobile ? "py-3 text-sm justify-start" : ""}`}
          >
            {isMobile ? "⚙️ Rules" : "Verification Rules"}
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="submitted" className="pt-2">
          <SubmittedDocuments />
        </TabsContent>
        
        <TabsContent value="types" className="pt-2">
          <IDTypesList />
        </TabsContent>
        
        <TabsContent value="rules" className="pt-2">
          <VerificationRulesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
